import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuite.NetSuiteRequestItemsSummary', {
    netAmountText: 'Amount:',
    taxAmountText: 'Tax:',
    totalAmountText: 'Total:',
    differentAmountWarningLabel1: 'Bill amount',
    differentAmountWarningLabel2: 'File amount',
    differentTaxTotalWarningLabel1: 'Bill tax total',
    differentTaxTotalWarningLabel2: 'File tax total',
    differentTotalWarningLabel1: 'Bill total',
    differentTotalWarningLabel2: 'File total',
    differentAmountWarningDescription: 'Bill amount differs from File amount',
    differentTaxTotalWarningDescription: 'Bill tax total differs from File tax total',
    differentTotalWarningDescription: 'Bill total differs from File total',
    invoiceNetAmountText: 'Subtotal:',
    invoiceTransactionDiscountText: 'Discount:',
    invoiceTaxAmountText: 'Tax:',
    invoiceTotalAmountText: 'Total:',
});
